import { IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, IActionResponse, IAppParams } from "../models";
import { ENDPOINTS } from "../config";
import { generateRequest, getFundListForFundSearch, getFundListForShareClassSearch, isNullOrUndefined } from "../utils";

export async function fetchFilters(options: IFilterRequest = {}, appParams: IAppParams): Promise<IActionResponse<IFundFilterResponse & IShareClassFilterResponse>> {
    if (!options.search) {
        options.search = [];
    }
    let fundList = getFundListForFundSearch(options.search, appParams);
    let fundOptions = Object.assign({ fundList } as IFilterRequest, options);
    fundOptions.search = [].concat(options.search.filter(s => BASE_FUND_FILTER_REQUEST.filterProperties.indexOf(s.property) > -1));


    let shareClassOptions = Object.assign({ fundList } as IFilterRequest, options);
    shareClassOptions.search = [].concat(options.search.filter(s => BASE_SHARE_CLASS_FILTER_REQUEST.filterProperties.indexOf(s.property) > -1));


    let baseSearchRequest = Object.assign({}, BASE_FUND_FILTER_REQUEST, fundOptions);
    let response = <IActionResponse<IFundFilterResponse & IShareClassFilterResponse>>{};
    let request = await fetch(ENDPOINTS.fund.getFilters, generateRequest("POST", baseSearchRequest));
    if (request.ok) {
        response.data = Object.assign({}, await request.json());
        baseSearchRequest = Object.assign({}, BASE_SHARE_CLASS_FILTER_REQUEST, shareClassOptions) as IFilterRequest;
        request = await fetch(ENDPOINTS.fund.getFilters, generateRequest("POST", baseSearchRequest));

        if (request.ok) {
            response.data = Object.assign(response.data, await request.json());
        } else {
            response.error = new Error(request.statusText);
        }
    } else {
        response.error = new Error(request.statusText);
    }
    response.data = orchestrateFilterValues(response);
    return response;
}

function orchestrateFilterValues(filterValues: IActionResponse<IFundFilterResponse & IShareClassFilterResponse>): IActionResponse<IFundFilterResponse & IShareClassFilterResponse> {
    let response = <IActionResponse<IFundFilterResponse & IShareClassFilterResponse>>{};
    for (let key in filterValues.data) {
        let orchestratedValues = filterValues.data[key].reduce((acc, curr) => {
            if (curr.value.indexOf("[") !== -1) {
                let parsedValues = JSON.parse(curr.value);
                for (let value of parsedValues) {
                    let doesExist = acc.filter((item) => item.value === value);
                    if (doesExist.length === 0) {
                        acc.push({ value: value, label: value });
                    }
                }
            }
            else {
                acc.push(curr);
            }
            return acc;
        }, []);

        response[key] = [].concat(orchestratedValues);
    }

    return response;
}

export const BASE_FUND_FILTER_REQUEST: IFilterRequest = {
    "type": "FUND",
    "filterProperties": ["asset_class", "fund_name", "style", "client_code", "regions"],
    "search": []
};

export const BASE_SHARE_CLASS_FILTER_REQUEST: IFilterRequest = {
    "type": "CLSS",
    "filterProperties": ["isin", "fund_key", "shareclass_letter", "currency", "share_type", "product_availability", "morningstar_rating"],
    "search": []
};


// WEBPACK FOOTER //
// ./src/client/data/filter.ts